<template>
    <div>
        <table class="table">
            <thead>
            <tr>
                <th v-for="(column, index) of columns" :key="`head-${index}`">
                    <div class="table-title" v-bind:class="column.classes || []">{{ column.label }}</div>
                </th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(row, indexRow) of rows">
                <tr :key="`row-${indexRow}`">
                    <td v-for="(column, indexI) of columns" v-bind:class="column.classes || []"
                        :key="`row-col-${indexI}`">
                        <div v-if="column.dataFunction" v-html="column.dataFunction(row[column.key])"></div>
                        <div v-else-if="column.key == 'details'">
                            <button @click="selectRow(row)"
                                    :title="(selectedRow == row ? 'Close' : 'Open') + ' the response strategy'"
                                    class="button button-detail">{{selectedRow == row ? "Close" : "Open"}}
                            </button>
                        </div>
                        <div v-else>{{row[column.key]}}</div>
                    </td>
                </tr>
                <tr v-if="selectedRow == row" :key="`row-detail-top-${indexRow}`">
                    <td v-for="(column, indexI) of columns" class="border-0 p-1 opened-up"
                        v-bind:class="column.classes || []"
                        :key="`row-col-${indexI}`">
                    </td>
                </tr>
                <tr v-if="selectedRow == row" :key="`row-detail-${indexRow}`">
                    <td :colspan="columns.length" class="row-detail border-0">
                        <slot name="rowdetail" v-bind:row="row"></slot>
                    </td>
                </tr>
                <tr v-if="selectedRow == row" :key="`row-detail-bottom-${indexRow}`">
                    <td v-for="(column, indexI) of columns" class="border-0 p-1 opened-down"
                        v-bind:class="column.classes || []"
                        :key="`row-col-${indexI}`">
                    </td>
                </tr>
            </template>
            </tbody>
        </table>
    </div>
</template>
<script>
    export default {
        name: "Table",
        props: {
            columns: Array,
            rows: Array
        },
        data() {
            return {
                selectedRow: null
            }
        },
        methods: {
            selectRow(row) {
                if (this.selectedRow && this.selectedRow == row) {
                    this.selectedRow = null;
                } else {
                    this.selectedRow = row;
                    this.$emit("open", row);
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    .button-detail {
        width: 120px;
    }
    .table th {
        padding: 1rem 0 0 0;
        margin: 0;
    }

    .table-title {
        min-height: 70px;
        padding: .375rem .75rem .75rem .75rem;

        &.left-row:first-child {
            border-top-left-radius: 10px;
        }

        &.right-row:first-child {
            border-top-right-radius: 10px;
        }
    }

    tbody {
        tr:last-child {
            .left-row {
                border-bottom-left-radius: 10px;
            }

            .right-row {
                border-bottom-right-radius: 10px;
            }
        }

        .row-detail {
            background-color: #eceff1;
            border-radius: 10px;
            max-width: 100px;
        }
    }

    .group {
        background-color: #eceff1;
    }

    .white-space {
        &.opened-up {
            position: relative;

            &::after {
                position: absolute;
                right: 0;
                bottom: 0;
                width: 20px;
                height: 20px;
                background: url("../../assets/img/icons/right-bottom-radius.svg");
                content: "";
            }

            &::before {
                position: absolute;
                left: 0;
                bottom: 0;
                width: 20px;
                height: 20px;
                background: url("../../assets/img/icons/left-bottom-radius.svg");
                content: "";
            }
        }

        &.opened-down {
            position: relative;

            &::after {
                position: absolute;
                right: 0;
                top: 0;
                width: 20px;
                height: 20px;
                background: url("../../assets/img/icons/right-top-radius.svg");
                content: "";
            }

            &::before {
                position: absolute;
                left: 0;
                top: 0;
                width: 20px;
                height: 20px;
                background: url("../../assets/img/icons/left-top-radius.svg");
                content: "";
            }
        }
    }

    .left-before-row {
        &.opened-up {
            position: relative;

            &::after {
                position: absolute;
                right: 0;
                bottom: 0;
                width: 20px;
                height: 20px;
                background: url("../../assets/img/icons/right-bottom-radius.svg");
                content: "";
            }
        }

        &.opened-down {
            position: relative;

            &::after {
                position: absolute;
                right: 0;
                top: 0;
                width: 20px;
                height: 20px;
                background: url("../../assets/img/icons/right-top-radius.svg");
                content: "";
            }
        }
    }

    .right-after-row {
        &.opened-up {
            position: relative;

            &::before {
                position: absolute;
                left: 0;
                bottom: 0;
                width: 20px;
                height: 20px;
                background: url("../../assets/img/icons/left-bottom-radius.svg");
                content: "";
            }
        }

        &.opened-down {
            position: relative;

            &::before {
                position: absolute;
                left: 0;
                top: 0;
                width: 20px;
                height: 20px;
                background: url("../../assets/img/icons/left-top-radius.svg");
                content: "";
            }
        }
    }
</style>

